// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607011427/js/" + chunkId + "." + {"44":"8eb4f1bf","225":"b7b84000","481":"1e568603","486":"6f27ee88","770":"d5b30ac1"}[chunkId] + ".0.7265337759002055.chunk.js";
};